import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';

const DonationPurposesSelect = ({ donationPurposes }) => {
  const defaultPurposeId = donationPurposes.find(({ default: val }) => val === true)?.id;
  const [purposeId, setPurposeId] = useState(defaultPurposeId);
  const description = donationPurposes.find(({ id }) => id === purposeId)?.pageDescription;

  return (
    <>
      <div className="md-form input-group mt-3 mb-0">
        <div className="w-100">
          <select
            className="form-control"
            id="transaction_form_purpose"
            name="transaction_form[donationPurposeId]"
            required="required"
            value={purposeId}
            onChange={e => setPurposeId(e.target.value)}
          >
            <option value="" disabled>
              Wybierz cel wpłaty
            </option>
            {donationPurposes.map(({ id, name }) => (
              <option key={id} value={id}>
                {name}
              </option>
            ))}
          </select>

          <AnimateHeight duration={500} height={description ? 'auto' : 0}>
            <p className="mb-0 mt-2">Cel darowizny: {description}</p>
          </AnimateHeight>
        </div>
      </div>
    </>
  );
};

DonationPurposesSelect.propTypes = {
  donationPurposes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      pageDescription: PropTypes.string,
    }),
  ).isRequired,
};

export default DonationPurposesSelect;
